import React, { useState } from "react";
import "./TxnLookup.css";
import { FaCalendar } from "react-icons/fa6";
import { DateRangePicker } from "react-date-range";
import { getDataForExcel } from "../../../config/LiveApi";
import { useSelector } from "react-redux";

function BulkStatusFile({
  setTypeData,
  typeData,
  setTransactionStatus,
  transactionStatus,
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  setBulkData,
  setShowBulkPayinStatus,
  setIsLoading,
  setShowBulkPayoutStatus,
}) {
  let token = useSelector((store) => store.userReducer.token);

  const [showPicker, setShowPicker] = useState(false);
  const [state, setState] = useState({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
    startTime: "00:00", // Default start time
    endTime: "23:59",   // Default end time
  });

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    setState({
      ...state,
      selection: ranges.selection,
    });

    // Update start and end dates with default times
    setStartDate(startDate.toISOString());
    setEndDate(endDate.toISOString());
  };

  const handleTimeChange = (e, type) => {
    const value = e.target.value;

    setState({
      ...state,
      [type === "start" ? "startTime" : "endTime"]: value,
    });
  };
  

  const handleApply = async (
    token,
    startDate,
    endDate,
    typeData,
    transactionStatus,
    setBulkData,
    setShowBulkPayinStatus,
    setShowPicker,
    setIsLoading,
    setShowBulkPayoutStatus
  ) => {
    setIsLoading(true);
    setShowPicker(false);
    try {
      const startISO = new Date(
        new Date(startDate).setHours(
          ...state.startTime.split(":").map(Number)
        )
      ).toISOString();

      const endISO = new Date(
        new Date(endDate).setHours(
          ...state.endTime.split(":").map(Number)
        )
      ).toISOString();

      let data = await getDataForExcel(
        token,
        startISO,
        endISO,
        typeData,
        transactionStatus
      );
      // console.log("data", data);
      if (data && data.dataForStatus) {
        const modifiedData = data.dataForStatus.map((item) => ({
          ...item,
          statusResponse: {},
          statusChecked: false,
          statusLoading: false,
        }));

        setBulkData(modifiedData);

        if (modifiedData[0].type === "payin") {
          setShowBulkPayoutStatus(false);
          setShowBulkPayinStatus(true);
        } else if (modifiedData[0].type === "payout") {
          setShowBulkPayinStatus(false);
          setShowBulkPayoutStatus(true);
        }
      } else {
        console.error("No data received from the API");
        setBulkData([]);
        setShowBulkPayinStatus(false);
      }
    } catch (error) {
      console.error("Error fetching data for Excel:", error);
      setBulkData([]);
      setShowBulkPayinStatus(false);
    }

    setIsLoading(false);
  };

  return (
    <div>
      <div className="main-data-1">
        <div className="category">
          <p>Transaction Type :-</p>
        </div>
        <div className="category">
          <span>Pay In</span>
          <input
            type="checkbox"
            checked={typeData === "Payin"}
            name="Payin"
            onChange={(e) => {
              setTypeData(typeData === "Payin" ? "" : e.target.name);
            }}
          />
        </div>

        <div className="category">
          <span>Pay Out</span>
          <input
            type="checkbox"
            name="Payout"
            checked={typeData === "Payout"}
            onChange={(e) => {
              setTypeData(typeData === "Payout" ? "" : e.target.name);
            }}
          />
        </div>
      </div>
      {typeData && (
        <div className="main-data-1 check-mar">
          <div className="category">
            <p>Transaction Status :-</p>
          </div>
          <div className="category">
            <span>Processing</span>
            <input
              type="checkbox"
              checked={transactionStatus === "Processing"}
              name="Processing"
              onChange={(e) => {
                setTransactionStatus(
                  transactionStatus === "Processing" ? "" : e.target.name
                );
              }}
            />
          </div>

          <div className="category">
            <span>Failed</span>
            <input
              type="checkbox"
              name="Failed"
              checked={transactionStatus === "Failed"}
              onChange={(e) => {
                setTransactionStatus(
                  transactionStatus === "Failed" ? "" : e.target.name
                );
              }}
            />
          </div>

          <div className="category">
            <span>Both</span>
            <input
              type="checkbox"
              checked={transactionStatus === "Both"}
              name="Both"
              onChange={(e) => {
                setTransactionStatus(
                  transactionStatus === "Both" ? "" : e.target.name
                );
              }}
            />
          </div>
        </div>
      )}

      {transactionStatus && (
        <div className="main-data-1 check-mar">
          <div className="category">
            <p>Date and Time :-</p>
          </div>

          <button
            className="search-btn-inactivee"
            onClick={() => setShowPicker(!showPicker)}
          >
            <FaCalendar />
          </button>

          {showPicker && (
            <div className="picker-box-1">
              <div className="date-range-picker-container">
                <DateRangePicker
                  ranges={[state.selection]}
                  onChange={(e) => handleSelect(e)}
                />
                <div className="time-picker-container">
                  <div className="time-picker">
                    <label className="time-label">Start Time : </label>
                    <input
                      type="time"
                      value={state.startTime}
                      onChange={(e) => handleTimeChange(e, "start")}
                    />
                  </div>
                  <div>
                    <label className="time-label">End Time : </label>
                    <input
                      className="time-picker"
                      type="time"
                      value={state.endTime}
                      onChange={(e) => handleTimeChange(e, "end")}
                    />
                  </div>
                </div>
                <button
                  onClick={() =>
                    handleApply(
                      token,
                      startDate,
                      endDate,
                      typeData,
                      transactionStatus,
                      setBulkData,
                      setShowBulkPayinStatus,
                      setShowPicker,
                      setIsLoading,
                      setShowBulkPayoutStatus
                    )
                  }
                  className="apply-button"
                >
                  Apply
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      {transactionStatus && (
      <div className="main-data-1" style={{marginTop:'10px'}}>
        <div className="category">
          <p>Selected Date & Time Range :-</p>
        </div>
        <div className="category">
          <span>
          {(state.selection.startDate).toLocaleDateString()} <span style={{color:'grey'}}> & 
            </span> {state.startTime}  -  {(state.selection.endDate).toLocaleDateString()} <span style={{color:'grey'}}> & </span>
               {state.endTime}
          </span>
        </div>
      </div>
      )}
    </div>
  );
}

export default BulkStatusFile;
